import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Controller, EffectFade, Thumbs, Lazy, Navigation, Zoom } from "swiper";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/lazy";
import "swiper/css/controller";
import "swiper/css/effect-fade";
import productImage1 from "../../assets/images/pro-3.png";
import productImage2 from "../../assets/images/pro-1.png";
import productImage3 from "../../assets/images/pro-2.png";

const images = [
  productImage1,
  productImage2,
  productImage3,
  productImage1,
  productImage2,
];

const ProductGallery = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const swiperProps /** @type swiper */ = {
    modules: [EffectFade, Thumbs, Lazy, Navigation, Controller, Zoom],
    zoom: true,
    lazy: true,
    effect: "fade",
    preloadImages: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  };

  const thumbsProps /** @type swiper */ = {
    modules: [Controller, Navigation, Thumbs],
    slidesPerView: 4,
    spaceBetween: 20,
    watchOverflow: false,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    allowSlideNext: true,
    allowSlidePrev: true,
    controller: true,
    breakpoints: {
      0: {
        direction: "horizontal",
      },
      768: {
        direction: "vertical",
      },
    },
    onSwiper: setThumbsSwiper,
  };

  return (
    <div className="product flex xs:flex-col-reverse md:flex-row select-none">
      {/* Thumbs */}

      <Swiper
        {...thumbsProps}
        className="product-thumbs xs:w-full md:w-[84px] xs:h-full md:h-[400px]"
      >
        {images.map((image, index) => {
          return (
            <SwiperSlide
              key={index}
              className={`md:min-w-[65px] xs:h-[50px] md:h-24 opacity-70 cursor-pointer transition-all duration-200 flex justify-center items-center self-center place-self-center`}
            >
              <div className="image w-full h-full flex justify-center items-center overflow-hidden border-2 border-[#eee] rounded-[10px]">
                <img src={image} alt="" className="h-full object-scale-down" />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Slides */}
      <Swiper
        {...swiperProps}
        className="w-full h-[400px]"
      >
        {images.map((image, index) => {
          return (
            <SwiperSlide
              className="flex items-center justify-center"
              key={index}
            >
              <div className="image w-full h-full flex">
                <img
                  src={image}
                  alt=""
                  className="h-auto w-full object-scale-down"
                />
              </div>
            </SwiperSlide>
          );
        })}
        <div className="swiper-button-next h-8 w-8 border rounded-full shadow-md after:text-base after:content-['next'] after:text-[#565656] after:font-bold"></div>
        <div className="swiper-button-prev h-8 w-8 border rounded-full shadow-md after:text-base after:content-['prev'] after:text-[#565656] after:font-bold"></div>
      </Swiper>
    </div>
  );
};

export default ProductGallery;
